module.exports = __webpack_public_path__ + "img/9788958281689.ee56ed2e.jpg";